<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title" *ngIf="!inEditMode">{{ note.title }}</h4>
    <h4 class="modal-title" *ngIf="inEditMode">Edit Event Note</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="!inEditMode">
    <p *ngIf="note.text !== ''" style="white-space: pre-wrap">{{ note.text }}</p>
    <p *ngIf="note.text === ''" class="text-muted">
      No text provided
    </p>
  </div>

  <div class="modal-body" *ngIf="inEditMode">

    <div class="alert alert-danger text-center mb-3" role="alert"
         *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <div class="form-group">
      <label for="titleInput">Title</label>
      <input type="text" class="form-control" id="titleInput" name="title" required [(ngModel)]="note.title">
      <div class="form-text text-danger">{{ errors.title }}</div>
    </div>

    <div class="form-group">
      <label for="textInput">Text (optional)</label>
      <textarea class="form-control" id="textInput" name="text" [(ngModel)]="note.text"></textarea>
      <div class="form-text text-danger">{{ errors.text }}</div>
    </div>

  </div>

  <div class="modal-footer" *ngIf="!inEditMode">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Back
    </button>
    <button class="btn btn-primary" type="button"
            (click)="inEditMode = true">
      Edit
    </button>
  </div>

  <div class="modal-footer" *ngIf="inEditMode">
    <button class="btn btn-danger" type="button"
            *ngIf="!loadingSubmit"
            (click)="handleRemove()">
      Remove
    </button>
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary" type="button"
            *ngIf="!loadingSubmit"
            (click)="handleSave()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
